import { useEffect, useId, useRef, type ReactNode } from "react";
import { X, LoaderCircle, FolderOpen } from "lucide-react";
export { ThemePicker } from "./theme";

export function Brand({ small = false }: { small?: boolean }) {
  return (
    <div className={`brand ${small ? "small" : ""}`}>
      <span className="brand-symbol">
        <LogoMark />
      </span>
      <span>
        GDTool<span className="brand-period">.</span>
      </span>
    </div>
  );
}
/** Знак «gd» в стиле ИИ Артели; тот же рисунок лежит в public/logo.svg и favicon.svg. */
export function LogoMark() {
  return (
    <svg viewBox="0 0 208 208" aria-hidden="true">
      <path
        fill="#EDE6D6"
        fillRule="evenodd"
        d="M54 108a44 46 0 1 0 88 0a44 46 0 1 0 -88 0ZM82 108a20 27 0 1 0 40 0a20 27 0 1 0 -40 0Z"
      />
      <path fill="#EDE6D6" d="M136 32 158 14V146H136Z" />
      <path
        fill="#EDE6D6"
        d="M136 144H158C158 180 118 196 70 190 48 187 30 181 14 173 46 180 100 180 122 164 132 156 136 150 136 144Z"
      />
      <path
        fill="#D2A45A"
        d="M58 178C42 178 28 176 14 173 30 181 48 187 66 189 58 186 56 182 58 178Z"
      />
      <path fill="#5CE1D0" d="M92 142H136L141 155H87Z" />
      <path fill="#5CE1D0" d="M166 134h14v14h-14z" />
      <path fill="#5CE1D0" opacity=".65" d="M184 136h10v10h-10z" />
    </svg>
  );
}
export function Spinner() {
  return <LoaderCircle size={18} className="spin" aria-label="Загрузка" />;
}
export function Empty({
  title,
  children,
  action,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <div className="empty-icon">
        <FolderOpen size={28} strokeWidth={1.4} />
      </div>
      <h2>{title}</h2>
      <p>{children}</p>
      {action}
    </div>
  );
}
export function Modal({
  title,
  children,
  close,
}: {
  title: string;
  children: ReactNode;
  close: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null),
    id = useId();
  useEffect(() => {
    const d = dialog.current!;
    d.showModal();
    return () => d.close();
  }, []);
  return (
    <dialog
      ref={dialog}
      aria-labelledby={id}
      onCancel={(e) => {
        e.preventDefault();
        close();
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) close();
      }}
    >
      <div className="modal-inner">
        <div className="modal-heading">
          <h2 id={id}>{title}</h2>
          <button className="icon-button" onClick={close} aria-label="Закрыть">
            <X size={18} />
          </button>
        </div>
        {children}
      </div>
    </dialog>
  );
}
export const dateLabel = (value: string) =>
  new Intl.DateTimeFormat("ru", { day: "numeric", month: "short" }).format(
    new Date(value),
  );
